import React from 'react'
// view components
import { Table } from 'components/UI'
// components
import Row from './components/Row'
// constants
// context
import { KPIPageContext } from 'containers/KPIs/Register/layers/API'
import { TableManagementContext } from 'containers/Search/layers/BL'
// utils
import { getTableHeader } from 'utils/index'

const KPITable: React.FC = () => {
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, fields, refetch, totalCount, isRefetching } = React.useContext(KPIPageContext)

  const headers = [
    {
      id: 'entity.description',
      sortable: true,
      left: true,
      label: getTableHeader('description', fields, 'DESCRIPTION')
    },
    { id: 'status', sortable: false, left: true, label: getTableHeader('status', fields, 'STATUS') },
    { id: 'associatedWith', sortable: false, left: true, label: 'ASSOCIATED WITH' },
    { id: 'nextReview', sortable: false, left: true, label: 'NEXT REVIEW' },
    { id: 'resultDue', sortable: false, left: true, label: 'RESULT DUE' },
    { id: 'lastResult', sortable: false, left: true, label: 'LAST RESULT' },
    {
      id: 'ownedBy',
      sortable: false,
      left: true,
      label: getTableHeader('ownedByEmployeeOrPosition', fields, 'OWNED BY')
    }
  ]

  return (
    <Table
      data={data}
      page={page}
      title='Indicators'
      headers={headers}
      perPage={perPage}
      refetch={refetch}
      totalCount={totalCount}
      isLoading={isRefetching}
      onPageChange={handleSetPage}
      onPerPageChange={handleSetPerPage}>
      {({ data }) => data.map((item) => <Row key={item.id} data={item} fields={fields} />)}
    </Table>
  )
}

export default KPITable
